<template>
  <!-- 会员权益页 -->
  <div>
    <div id="videoPlayer" style="width: 100%; height: 100%" class="video-js videoBox" muted @contextmenu.prevent="handleContextMenu"></div>
    <div class="videoNme">
      <div class="name">{{ videoInfo.cwName }}</div>
      <div class="hangye">所属课程：{{ courseName }}</div>
    </div>

    <div class="tab">
      <div :class="tabIndex == '1' ? 'tablan active' : 'tablan'" @click="tabIndex = 1">
        课程章节
        <div class="bor" v-if="tabIndex == '1'"></div>
      </div>
      <div :class="tabIndex == '2' ? 'tablan active' : 'tablan'" @click="tabIndex = 2">
        温馨提示
        <div class="bor" v-if="tabIndex == '2'"></div>
      </div>
    </div>

    <div v-if="tabIndex == '1'" class="chaper">
      <div class="zjBox" v-for="(item, index) in chapterList" :key="item.cwId" @click="videoChange(item)">
        <!-- <div class="zjIndex">
          <div :class="videoInfo.chapterId == item.chapterId ? 'bq activeTitle' : 'bq'">第{{ index + 1 }}节</div>
          <div class="wcd">完成度：{{ videoInfo.chapterId == item.chapterId ? videoInfo.jinDu : item.jinDu }}%</div>
        </div> -->
        <div :class="videoInfo.chapterId == item.chapterId ? 'chName activeColor' : 'chName'">
          {{ item.cwName }}
        </div>

        <div class="xsOrBtn">
          <div class="xs"></div>
          <div class="btn activeBtn" v-if="videoInfo.chapterId == item.chapterId">正在播放</div>
          <div class="btn" v-else>播放</div>
        </div>
      </div>
    </div>

    <div v-if="tabIndex == '2'" class="wxts">
      <!-- <div>1.学习前务必填写完整的个人信息，否则无法登记学时证明；</div> -->
      <div>1.如果视频无法播放，推荐使用QQ浏览器；</div>
      <!-- <div>3.课程通过后可自主打印学时证明；</div> -->
      <div>2.如您需要发票请到缴费订单管理界面申领电子发票。</div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import 'xgplayer';
import HlsPlugin from 'xgplayer-hls';
import Player from 'xgplayer';
import { toStudyMain, toStudy, updateDBTrack } from '@/api/myClass';
import {toZykStudy}from '../../api/index'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      tabIndex: 1,
      TMvalid: false, //是否需要验证码，false不需要
      dialogVisible: false, //验证码弹框
      codeNum: '', //验证码结果
      configKey: '', //tm平台需要的key
      codeImg: '', //验证码图片
      codeId: '', //提交验证码必要参数
      chapterid: '', //提交验证码必要参数
      tmId: '', //提交验证码必要参数
      coursePlayTimeList: [],
      isNeedVerify: '', //是否需要验证
      codeResTime: '', //验证时间
      codeIndex: '',
      userId: '',
      getVerCodeTime: 1, //1分钟
      everyProVideo: 15, //假定视频总长度
      isVerify_0: false, //
      verifyChapter: '',
      verCodeCount: 0,
      codeStatus: false, //验证码检查状态
      isGetTmVerCodeByVideoPlayTimer: null, //定时器
      options: {
        autoplay: true, // 设置自动播放
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        preload: 'auto', // 预加载
        controls: true // 显示播放的控件
      },
      player: null,
      queryPams: {},
      chapterList: [], //目录
      videoInfo: {}, //当前播放数据
      lessonstatus: '', //学习状态0
      videoTime: 0,
      timer: null,
      allInt: false, //视频是否已完成 false未完成 true已完成
      className: '1',
      t: false, //是pc还是移动端
      jinDuId: '', //动态渲染当前播放视频进度
      foj: '', //进度
      isExam: '',
      zanKey: 0, //
      zanKey1: 1000, //
      courseName: '',
      timer1: null
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goStudy() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      getUrl().then(res => {
        if (isMobile) {
          window.location.replace(res.data.data.mobileCenterUrl + '?token=' + localStorage.getItem('token'));
        } else {
          window.location.replace(res.data.data.pcCenterUrl + '?token=' + localStorage.getItem('token'));
        }
      });
    },
    navTab(id) {
      this.className = id;
    },
    goBack() {
      this.$router.back();
    },

    //视频结束事件
    endVideo(t) {
      if (this.allInt) {
        let info = this.videoInfo.isFinal;
        let chapterId = this.videoInfo.chapterId;
        if (info == '1') {
          if (this.videoInfo.nextChapterId == '0') {
            return false;
          }
          //该视频是当前章节的最后一个,那么就重新调用接口,访问下一个。
          // this.queryPams.classId = this.$route.query.classId;
          this.queryPams.courseId = this.videoInfo.nextCourseId;
          this.queryPams.coursewareId = this.videoInfo.nextCwId;
          this.queryPams.chapterId = this.videoInfo.nextChapterId;
          toZykStudy(this.queryPams).then(res => {
            if (res.data.data.chapter.lessonstatus == 'completed') {
              this.allInt = true;
            } else {
              this.allInt = false;
            }
            this.videoInfo = res.data.data.chapter;
            this.getVideo(this.videoInfo);
          });
        } else {
          //如果不是最后一个，就正常播放下一个视频
          this.chapterList.forEach((item, index) => {
              if (item.chapterId == chapterId) {
                if (item.lessonstatus == 'completed') {
                  item.jinDu = 100;
                } else {
                  let time = this.player.currentTime;
                  item.jinDu = parseInt((time / item.period) * 100);
                }
                this.videoChange(this.chapterList[index + 1]);
              }
            if (item.chapterId == chapterId) {
            }
          });
        }
        return false;
      }
      if (this.videoInfo.period - Math.round(this.player.currentTime) <= 60) {
        this.lessonstatus = 'completed';
      } else {
        this.lessonstatus = 'incomplete';
      }
      console.log('this.videoInfo: ', this.videoInfo);
      var position = Math.round(this.player.currentTime), //当前视频播放时长
        duration = this.videoInfo.period, //章节总时长
        courseId = this.queryPams.courseId, //课程id
        coursewareId = this.videoInfo.cwId, //课件id
        chapterId = this.videoInfo.chapterId, //章节id
        trackMode = this.videoInfo.cwScorm, //视频跟踪类型（01按时间点跟踪、02按知识点跟踪）
        lessonstatus = this.lessonstatus, //学习状态
        classId = this.queryPams.classId;
      let cwPeriod = this.videoInfo.cwPeriod;
      let creditnum = this.videoInfo.creditnum;
      let period = this.videoInfo.period;
      // lessonLocation = this.dataMsg.lessonLocation, //当前章节时长
      // suspendData = this.dataMsg.suspendData,
      let flag = '0'; //是否为老学员，默认0
      var params = {
        position: position,
        duration: duration,
        courseId: courseId,
        coursewareId: coursewareId,
        chapterId: chapterId,
        trackMode: trackMode,
        lessonstatus: lessonstatus,
        classId: classId,
        // lessonLocation: lessonLocation,
        // suspendData: suspendData,
        flag: flag,
        cwPeriod: cwPeriod,
        creditnum: creditnum,
        period: period
      };
      updateDBTrack(params).then(res => {
        let info = this.videoInfo.isFinal;
        let chapterId = this.videoInfo.chapterId;
        if (info == '1') {
          if (this.videoInfo.nextChapterId == '0') {
            return false;
          }
          //该视频是当前章节的最后一个,那么就重新调用接口,访问下一个。
          // this.queryPams.classId = this.$route.query.classId;
          this.queryPams.courseId = this.videoInfo.nextCourseId;
          this.queryPams.coursewareId = this.videoInfo.nextCwId;
          this.queryPams.chapterId = this.videoInfo.nextChapterId;
          toZykStudy(this.queryPams).then(res => {
            if (res.data.data.chapter.lessonstatus == 'completed') {
              this.allInt = true;
            } else {
              this.allInt = false;
            }
            this.videoInfo = res.data.data.chapter;
            this.getVideo(this.videoInfo);
          });
          toStudyMain(this.queryPams).then(res => {
            if (res.data.data.isSpot == '01') {
              this.$message('您还未报名公需课，请先报名再来学习！');
              window.open(res.data.data.TmUrl);
              return false;
            }

            this.chapterList = res.data.data.courseList;
            this.chapterList.forEach(item => {
              if (item.chapterhours) {
                item.resLos = parseInt((item.chapterhours / item.period) * 100) + '%';
              } else {
                item.resLos = '未学习';
              }
            });
          });
        } else {
          //如果不是最后一个，就正常播放下一个视频
          this.chapterList.forEach((item, index) => {
              if (item.chapterId == chapterId) {
                let time = this.player.currentTime;
                item.jinDu = parseInt((time / item.period) * 100);
                this.videoChange(this.chapterList[index + 1]);
              }
            if (item.chapterId == chapterId) {
            }
          });
        }
      });
      console.log('结束');
    },
    //两分钟记录一下时长
    updateDBTrack() {
      if (this.allInt) {
        return false;
      }
      if (this.videoInfo.period - Math.round(this.player.currentTime) <= 120) {
        this.lessonstatus = 'completed';
      } else {
        this.lessonstatus = 'incomplete';
      }
      var position = Math.round(this.player.currentTime), //当前视频播放时长
        duration = this.videoInfo.period, //章节总时长
        courseId = this.queryPams.courseId, //课程id
        coursewareId = this.videoInfo.cwId, //课件id
        chapterId = this.videoInfo.chapterId, //章节id
        trackMode = this.videoInfo.cwScorm, //视频跟踪类型（01按时间点跟踪、02按知识点跟踪）
        lessonstatus = this.lessonstatus, //学习状态
        classId = this.queryPams.classId;
      let cwPeriod = this.videoInfo.cwPeriod;
      let creditnum = this.videoInfo.creditnum;
      let period = this.videoInfo.period;
      // lessonLocation = this.dataMsg.lessonLocation, //当前章节时长
      // suspendData = this.dataMsg.suspendData,
      let flag = '0'; //是否为老学员，默认0
      var params = {
        position: position,
        duration: duration,
        courseId: courseId,
        coursewareId: coursewareId,
        chapterId: chapterId,
        trackMode: trackMode,
        lessonstatus: lessonstatus,
        classId: classId,
        // lessonLocation: lessonLocation,
        // suspendData: suspendData,
        flag: flag,
        cwPeriod: cwPeriod,
        creditnum: creditnum,
        period: period
      };
      updateDBTrack(params).then(res => {
        let info = this.videoInfo.chapterId;

        this.chapterList.forEach(item => {
          item.chapterList.forEach(v => {
            if (v.chapterId == info) {
              v.jinDu = Math.round(res.data.data.jindu);
              console.log(v);
            }
          });
        });
      });
    },
    videoChange(item) {
      this.updateDBTrack();
      // this.queryPams.classId = this.$route.query.classId;
      this.queryPams.courseId = item.courseId;
      this.queryPams.coursewareId = item.cwId;
      this.queryPams.chapterId = item.chapterId;
      toZykStudy(this.queryPams).then(res => {
        if (res.data.data.chapter.lessonstatus == 'completed') {
          this.allInt = true;
        } else {
          this.allInt = false;
        }
        this.videoInfo = res.data.data.chapter;
        this.getVideo(this.videoInfo);
        this.gettToStudyMain();
        window.scrollTo(0, 0);
      });
    },
    getData() {
      // this.queryPams.classId = this.$route.query.classId;
      this.queryPams.courseId = this.$route.query.courseId;
      this.queryPams.coursewareId = this.$route.query.courseWareId;
      this.queryPams.chapterId = '';
      this.isExam = '02';
      toZykStudy(this.queryPams).then(res => {
        console.log(res);

        this.chapterid = res.data.data.chapter.chapterId;
        this.TMvalid = res.data.data.TMvalid;
        this.userId = res.data.data.userId;
        //this.getTrainSupervision();
        if (res.data.data.chapter.lessonstatus == 'completed') {
          this.allInt = true;
        } else {
          this.allInt = false;
        }
        this.videoInfo = res.data.data.chapter;
        this.gettToStudyMain();
        this.getVideo(this.videoInfo);
      });
    },
    gettToStudyMain() {
      toStudyMain({ courseId: this.$route.query.courseId }).then(res => {
        this.chapterList = res.data.data.courseChapterList.rows;
        console.log(this.chapterList);
      });
    },
    getVideo(videoUrl) {
      if (this.player !== null) {
        this.player.destroy('videoPlayer');
      }
      let ignores = [];
      // this.player = Videojs('videoPlayer', this.options);
      //中经网一路学的课程
      if (videoUrl.sourceVideo == '01' || videoUrl.sourceVideo == '02') {
        this.player = new Player({
          id: 'videoPlayer',
          autoplay: true,
          playsinline: true,
          url: videoUrl.launch
        });
      } else {
        //判断视频源是否是m3u8的格式
        //正常课程
        if (/\.m3u8$/.test(videoUrl.launch)) {
          let ignores = [];
          //判断视频源是否是m3u8的格式
          this.player = new Player({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            url: videoUrl.launch,
            plugins: [HlsPlugin] // 第二步
          });
        } else {
          let url = videoUrl.launch + '.mp4';
        
          this.player = new Player({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            url: url,
          });
        }
      }
      if (this.videoInfo.lessonstatus == 'completed') {
        this.player.currentTime = 0;
      } else {
        this.player.currentTime = this.videoInfo.chapterhours;
      }
      this.player.play();
      // this.player.on('loadstart', function () {});
      // this.player.on('progress', function () {});
      // this.player.on('loadedmetadata', function () {});
      // this.player.on('canplaythrough', function () {});
      // this.player.on('waiting', function () {});
      // this.player.on('play', function () {});
      // this.player.on('playing', function () {});
      // this.player.on('pause', function () {});
      let _this = this;
      // _this.player.play();
      _this.player.on('ended', function () {
        _this.endVideo();
      });
      // this.player.on('error', function () {});
      // this.player.on('currentTime', function () {});
      // this.player.on('seeked', function () {});
      // this.player.on('ratechange', function () {});
      _this.player.on('timeupdate', function () {});
      // this.player.on('volumechange', function () {});
      // this.player.on('stalled', function () {});
    },
    //获取验证码
    getTmVerCode(time) {
      this.codeResTime = time;
      let query = {
        playTime: time.toString(),
        configKey: this.configKey
      };
      getTmVerCode(query).then(res => {
        let result = JSON.parse(res.data.data.data);

        if (result.result == '200') {
          if (result.data.couldAnswerCount == -1 || (result.data.couldAnswerCount != -1 && result.data.remainAnswerCount > 0)) {
            this.codeImg = 'data:image/jpeg;base64,' + result.data.content;
            this.codeId = result.data.id;
            this.dialogVisible = true;
            this.player.pause();
          } else {
            this.getTmVerCode(this.codeResTime + this.getVerCodeTime * 60);
          }
        }
        if (result.result == '505') {
          this.player.play();
          return false;
        }

        if (result.result == '500' || result.data.result == '503') {
          this.$message('无权限，请联系管理员！');
          this.$router.back();
          return false;
        }

        if (result.result == '506') {
          this.codeStatus = true;
          //当前节点时间验证过了,验证下一个时间
          this.getTmVerCode(this.codeResTime + this.getVerCodeTime * 60);
          this.player.play();
          return false;
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.courseName = this.$route.query.courseName;
    this.getData();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.timer = setInterval(() => {
      this.updateDBTrack();
    }, 4 * 60 * 1000);
    this.timer1 = setInterval(() => {
      // this.updateDBTrack();
      let num  = parseInt((this.player.currentTime / this.player.duration) * 100)
      this.videoInfo.jinDu = num > 100 ? 100 : num;
    }, 10 * 1000);
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
    if (this.player !== null) {
      this.player.destroy('videoPlayer');
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
#videoPlayer {
  margin-top: 50px;
  width: 100% !important;
  height: 211px !important;
}
.videoNme {
  width: 100%;
  height: 84px;
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  padding: 20px 15px;
  .name {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333333;
    font-size: 16px;
  }
  .hangye {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
    margin-top: 7px;
    font-size: 13px;
  }
}

.tab {
  display: flex;
  margin-top: 28px;
  padding: 0 15px;
  .tablan {
    position: relative;
    margin-right: 26px;
    font-size: 15px;
    color: #333;
    .bor {
      position: absolute;
      bottom: 2px;
      left: 0;
      width: 64px;
      height: 5px;
      background: linear-gradient(90deg, #2a70f2 0%, rgba(42, 112, 242, 0) 100%);
      border-radius: 0px 0px 0px 0px;
    }
  }
  .active {
    font-size: 16px;
    font-weight: 600;
  }
}

.chaper {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  min-height: 498px;
  padding: 15px;
  .zjBox {
  display: flex;
    margin-bottom: 35px;
    .activeTitle {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .activeColor {
      color: #2a70f2 !important;
    }
    .activeBtn {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .zjIndex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bq {
        width: 48px;
        height: 24px;
        background: #f6f8fa;
        border-radius: 4px 4px 4px 4px;
        color: #666666;
        font-size: 13px;
        text-align: center;
        line-height: 24px;
      }
      .wcd {
        color: #9d9d9d;
        font-size: 12px;
      }
    }
    .chName {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      margin: 10px 0 1px 0;
      font-weight: 500;
    }
    .xsOrBtn {
      display: flex;
      justify-content: space-between;
      .xs {
        margin-top: 8px;
        color: #999999;
        font-size: 13px;
      }
      .btn {
        margin-top: 4px;
        width: 74px;
        height: 32px;
        background: #f3f3f5;
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #2a70f2;
      }
    }
  }
}

.wxts {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  padding: 20px 15px;
  color: #666666;
  font-size: 13px;
  line-height: 25px;
}
</style>
